import React from 'react';
import { AlertTriangle, Clock, TrendingDown } from 'lucide-react';

const Problema = () => {
  const problemas = [
    {
      icon: <AlertTriangle className="text-reset-gold" size={32} />,
      title: "Miedo a la fuga de datos",
      description: "El uso de modelos públicos pone en riesgo el secreto profesional y la confidencialidad de tus clientes."
    },
    {
      icon: <Clock className="text-reset-gold" size={32} />,
      title: "Pérdida de rentabilidad",
      description: "Tareas repetitivas y mecánicas consumen el 80% de tu tiempo facturable sin aportar valor real."
    },
    {
      icon: <TrendingDown className="text-reset-gold" size={32} />,
      title: "Parálisis por análisis",
      description: "La avalancha de herramientas nuevas genera indecisión y retrasa la adopción de tecnología crítica."
    }
  ];

  return (
    <section id="problema" className="bg-reset-dark py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-white mb-6">
            La brecha <span className="italic text-reset-gold">tecnológica</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            La abogacía tradicional está muriendo por saturación. Mientras otros intentan entender qué es un prompt, tú estarás cerrando casos en la mitad de tiempo con la misma precisión jurídica.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {problemas.map((item, index) => (
            <div 
              key={index}
              className="bg-reset-black border border-reset-gold/20 p-8 hover:border-reset-gold/50 transition-all group"
            >
              <div className="mb-4">{item.icon}</div>
              <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-reset-gold transition-colors">
                {item.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-2xl text-reset-gold font-light italic">
            "El coste de no actuar es mucho mayor que el de transformarse"
          </p>
        </div>
      </div>
    </section>
  );
};

export default Problema;